import { agencyPath, createRequestWithComputedFilters, customerPath } from '@/utils/api'
import store from '@/store'
import network from '@/utils/network'

/**
 * Récupère les rapports d'intervention d'une agence
 * @type {function(?{filters?: *, ...opt}): *}
 */
export const fetchAgencyInterventionReports = createRequestWithComputedFilters(
  async (params) => {
    const slugAgency = store.getters['user/agencySlug']
    const r = await network.post(`agency/${slugAgency}${customerPath()}/fetch/intervention-reports`, params)
    return r.data
  },
  {
    filters: {
      site: 'all',
      customer: 'all'
    }
  })

/**
 * Récupère les rapports d'intervention d'une agence en PDF
 * @type {function(?{filters?: *, ...opt}): *}
 */
export const getAgencyInterventionReportsPdf = createRequestWithComputedFilters(
  async (params) => {
    const slugAgency = store.getters['user/agencySlug']
    const r = await network.post(`agency/${slugAgency}${customerPath()}/fetch/intervention-reports/pdf`, params)
    return r.data
  },
  {
    filters: {
      site: 'all',
      customer: 'all'
    }
  })

/**
 * Créé / met à jour un rapport d'intervention
 * @returns {Promise<>}
 */
export const postAgencyInterventionReport = async (interventionReport) => {
  const r = await network.post(`${agencyPath()}${customerPath()}/intervention-report`, interventionReport)
  return r.data
}

/**
 * Récupère le base64 du bon d'inter
 * @returns {Promise<>}
 */
export const getAgencyInterventionReportPdf = async (interventionReport) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`agency/${slugAgency}${customerPath()}/intervention-report/${interventionReport.id}/pdf`, interventionReport)
  return r.data
}
